var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CrudLayout',{attrs:{"resource-name":_vm.resourceName,"title":_vm.title}},[_c('PageWineAdForm',{attrs:{"loading":_vm.loading,"reset-action":_vm.reset,"save-action":_vm.createItemAction,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }